import React from "react";
import { VscFilePdf, VscFileZip, VscFile, VscFileMedia } from "react-icons/vsc";
import { Link } from "react-router-dom";

const BYTE = 1000;
const getKB = (bytes) => Math.round(bytes / BYTE);

const FileIcon = ({ children }) => {
  return <span className="text-4xl">{children}</span>;
};

const isExternalUrl = (url) => /^https?:\/\//i.test(url);

const FileItem = (props) => {
  const { file, children, exist } = props;
  const { type, name, size } = file;

  const renderThumbnail = () => {
    const isImageFile = type?.split("/")[0] === "image";

    if (isImageFile && !exist) {
      return (
        <img
          className="upload-file-image"
          src={URL.createObjectURL(file)}
          alt={`file preview ${name}`}
        />
      );
    }
    if (isImageFile) {
      return (
        <FileIcon>
          <VscFileMedia />
        </FileIcon>
      );
    }

    if (type === "application/zip") {
      return (
        <FileIcon>
          <VscFileZip />
        </FileIcon>
      );
    }

    if (type === "application/pdf") {
      return (
        <FileIcon>
          <VscFilePdf />
        </FileIcon>
      );
    }

    return (
      <FileIcon>
        <VscFile />
      </FileIcon>
    );
  };

  return (
    <div className="upload-file">
      <div className="flex">
        <div className="upload-file-thumbnail">{renderThumbnail()}</div>
        <div className="upload-file-info">
          {exist ? (
            isExternalUrl(name) ? (
              <a
                href={name}
                target="_blank"
                rel="noopener noreferrer"
                className="upload-file-name underline cursor-pointer"
              >
                {name}
              </a>
            ) : (
              <Link
                to={name}
                target="_blank"
                className="upload-file-name underline cursor-pointer"
              >
                {name}
              </Link>
            )
          ) : (
            <h6 className="upload-file-name">{name}</h6>
          )}
          {!exist && <span className="upload-file-size">{getKB(size)} kb</span>}
        </div>
      </div>
      {children}
    </div>
  );
};

export default FileItem;
